import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { Theme } from 'hephaestus/core';

dayjs.extend(utc);
dayjs.extend(timezone);

const NY_TIMEZONE = 'America/New_York';

type MarketStatus = {
  /** Stable identifier — translate via `t('snapshotCard:marketStatus.<key>')`. */
  key: 'preMarket' | 'open' | 'afterHours' | 'closed';
  /** English fallback label. Prefer translating via `key` in user-facing copy. */
  label: 'Pre-Market' | 'Market Open' | 'After Hours' | 'Market Closed';
  color: string;
  dot: string;
};

/** Determine US equity market status based on `now` in America/New_York. */
export const getMarketStatus = (theme: Theme, now: Date): MarketStatus => {
  const et = dayjs(now).tz(NY_TIMEZONE);
  const timeMinutes = et.hour() * 60 + et.minute();
  if (timeMinutes >= 240 && timeMinutes < 570)
    return {
      key: 'preMarket',
      label: 'Pre-Market',
      color: theme.color.warning,
      dot: theme.color.warning,
    };
  if (timeMinutes >= 570 && timeMinutes < 960)
    return {
      key: 'open',
      label: 'Market Open',
      color: theme.color.positive,
      dot: theme.color.positive,
    };
  if (timeMinutes >= 960 && timeMinutes < 1200)
    return {
      key: 'afterHours',
      label: 'After Hours',
      color: theme.color.warning,
      dot: theme.color.warning,
    };
  return {
    key: 'closed',
    label: 'Market Closed',
    color: theme.color.onSurfaceVariant,
    dot: theme.color.onDisabled,
  };
};
